var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23ac0cd87f90c38f7343d0ebc1f0b63a1675139c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@firastar"]={id:"23ac0cd87f90c38f7343d0ebc1f0b63a1675139c"};
      